import planBase from "./planBase.js";
import alignementHorizontalDefinition from "../../definition/alignementHorizontal.js";
import vueStore from "../../../config.js"
import * as namespaceStore from "../../../namespaceStore.js"
import fontWeightDefinition from "../../definition/fontWeight.js";

export default class TextPlan extends planBase {
    objectType = "TextPlanItem";
    styleColor = '#1a365d'; // Bleu foncé

    constructor(args = {}) {
        super(args);
        this.objectToClassValue(args);
    }

    objectToClassValue(args = {}) {
        super.objectToClassValue(args);
    }

    static get Name() {
        return "Text Plan";
    }

    get changeableProperty() {
        const parentProperty = super.changeableProperty;
        return [
            ...parentProperty.filter(el => el.type != "objectInput" && el.type != "arrayInput"),
            { name: "Text", text: "Texte", type: "textInput", dataType: "string" },
            { name: "TextFontSize", text: "Taille du texte", type: "numberInput", dataType: "number" },
            { name: "TextAlignment", text: "Alignement", type: "selectInput", dataType: "string", options: alignementHorizontalDefinition, optionsType: "idSoft" },
            { name: "TextColor", text: "Couleur du texte", type: "colorInput", dataType: "string" },
            { name: "TextPolice", text: "Police de caractères", type: "selectInput", dataType: "string", style: "fontFamily", options: vueStore.getters[namespaceStore.THEME + "/ressourcesByType"]("font"), optionsType: "idSoft" },
            { name: "TextShadowOffsetX", text: "Décalage horizontal de l'ombre", type: "numberInput", dataType: "number" },
            { name: "TextShadowOffsetY", text: "Décalage vertical de l'ombre", type: "numberInput", dataType: "number" },
            { name: "TextShadowStrokeWidth", text: "Largeur de l'ombre", type: "numberInput", dataType: "number" },
            { name: "TextShadowColor", text: "Couleur de l'ombre", type: "colorInput", dataType: "string" },
            { name: "TextFontStyle", type: "selectInput", dataType: "string", options: fontWeightDefinition, optionsType: "idSoft" },
            ...parentProperty.filter(el => el.type == "objectInput" || el.type == "arrayInput")
        ];
    }

    getStyle(currentElementIndex = null) {
        let style = {
            ...super.getStyle(currentElementIndex),
            fontSize: `${this.TextFontSize}px`,
            fontWeight: `${this.TextFontStyleName}`,
            color: `${this.TextColor}`,
            fontFamily: `${this.TextPoliceName}`,
            justifyContent: this.TextAlignmentAlignement,
            position: 'absolute',
        }
        return style;
    }

    toExportObject(variableArray = [], ressourceArray = []  ) {
        return {
            ...super.toExportObject(variableArray, ressourceArray),
            text: this.valueByVariable(this.Text, variableArray),
            textColor: this.hexColorValue(this.TextColor),
            textShadowColor: this.hexColorValue(this.TextShadowColor),
            textShadowOffsetX: this.TextShadowOffsetX,
            textShadowOffsetY: this.TextShadowOffsetY,
            textShadowStrokeWidth: this.TextShadowStrokeWidth,
            textPolice: this.TextPoliceName,
            textPoliceDirectory: "@" + this.TextPoliceDirectory + "@",
            textFontSize: this.TextFontSize,
            textFontStyle: this.TextFontStyleName,
            textAlignment: this.TextAlignmentName,
        };
    }

    toObject(minify = false) {
        return {
            ...super.toObject(minify),
            text: this.Text,
            textColor: this.TextColor,
            textShadowColor: this.TextShadowColor,
            textShadowOffsetX: this.TextShadowOffsetX,
            textShadowOffsetY: this.TextShadowOffsetY,
            textShadowStrokeWidth: this.TextShadowStrokeWidth,
            textPolice: this.TextPoliceName,
            textFontSize: this.TextFontSize,
            textFontStyle: this.TextFontStyleName,
            textAlignment: this.TextAlignmentName,
        };
    }

    static variableOfInstance() {
        return [
            ...super.variableOfInstance(),
            { property: "Text", construct: String, jsType: "String", isVariable: true },
            { property: "TextFontSize", construct: Number, jsType: "Number" },
            { property: "TextFontStyle", construct: String, jsType: "String" },
            { property: "TextAlignment", construct: String, jsType: "String" },
            { property: "TextPolice", construct: String, jsType: "String" },
            { property: "TextPoliceDirectory", construct: String, jsType: "String", isRessource: true },
            { property: "TextColor", construct: String, jsType: "String" },
            { property: "TextShadowColor", construct: String, jsType: "String" },
            { property: "TextShadowOffsetX", construct: Number, jsType: "Number" },
            { property: "TextShadowOffsetY", construct: Number, jsType: "Number" },
            { property: "TextShadowStrokeWidth", construct: Number, jsType: "Number" },
        ];
    }
}
